import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import moment from 'utils/moment';
import styles from './form.module.scss';
import Loading from '../../../../components/loading';
import Button from '../../../../components/button/button';
import { GetFileName, S3Uploads } from '../../../services';
import HeaderBack from '../../../../components/headerBack';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import Collapsible from '../../../../components/collapsible/Collapsible';
import CustomFields from '../../../../components/customFields/CustomFields';
import { checkExistingApprovedApplication, clearState, getAdpDefaultFields,
   fetchspecificAdpLogs, clearDetailsState,
   handleClearApprovedApplicationState, initiateApplication, initiateDraftPermit,
   clearDraftState, handleClearInitiateState, checkInitiatePermit, deleteSaveAsDraftAdpLog,
   makeAdpPayment, getAdpCategories } from '../../redux/action';
import { getThreeLetterCountryCode } from '../../../../utils/helpers';
import SectionHeader from '../../../../components/sectionHeader';
import ReqAttachments from '../Components/ReqAttachments';
import Modal from '../../../../components/modal';
import DeleteConfirmation from '../../../../components/deleteConfirmation/deleteConfirmation';
import PaymentPage from '../Components/PaymentPage';
import { getFeeWithInvoice, SaveAlert } from '../../components/ActionCompo';
import OfflinePayment from '../Components/OfflinePayment';
import { handleSignature, valueType } from '../../components/PermitData';

const AdpDriverPortalForm = (props) => {
  const { draftApp } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const profile = useSelector(state => state.auth.profile);
  const ordering = useSelector(state => state.permitManagement?.AdpOrder);
  const customFields = useSelector(state => state.permitManagement?.AdpCSchema);
  const defaultFields = useSelector(state => state.permitManagement?.AdpDSchema);
  const paymentActionStatus = useSelector(state => state?.permitManagement?.makeAdpPaymentAction);
  const getApplicationResponse = useSelector(state => state?.permitManagement?.getApplicationResponse);
  const existingApprovedAppInfo = useSelector(state => state?.permitManagement?.approvedApplicationData);
  const countrycode = useSelector(state => state.auth.profile.portal_airport.country_code);
  const installationId = useSelector(state => state.auth.profile.portal_airport.backend_id);
  const submissionStatus = useSelector(state => state.permitManagement?.adpInitiationStatus);
  const getSchemaStatus = useSelector(states => states?.permitManagement?.adpGetSchemaStatus);
  const notes = useSelector(state => state.permitManagement?.adpSchema?.default_fields?.notes);
  const reqAttach = useSelector(state => state.permitManagement?.adpSchema?.default_fields?.required_attachements);
  const adpSettings = useSelector(state => state?.permitManagement?.adpDefaultFields);
  const applicationDetails = useSelector(state => state?.permitManagement?.specificLog);
  const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
  const feeTypesList = useSelector(state => state?.permitManagement?.adpFeeWithCategoriesList);
  const adpSchemaSettings = useSelector(state => state?.permitManagement?.adpSchemaSettings);
  const initiatedPermitData = useSelector(states => states?.permitManagement?.initiatedPermitData);
  const initiateStatus = useSelector(states => states?.permitManagement?.checkInitiatedPermitAction);
  const getDetatilStatus = useSelector(state => state?.permitManagement?.loader);
  const actionApplicationDetails = useSelector(state => state?.permitManagement?.actionApplicationDetails);
  const initiateDraftApplicationAction = useSelector(state => state?.permitManagement?.initiateDraftApplicationAction);
  const checkApprovedApplicationAction = useSelector(state => state?.permitManagement?.checkApprovedApplicationAction);
  const actionDeleteDraftApplication = useSelector(states => states?.permitManagement?.actionDeleteDraftADPApplication);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [state, setState] = useState({
    answers: {
      attachments: [],
      company: profile?.current_tenant?.name
    },
    req_attachments: {}
  });
  const [stage, setStage] = useState('application');
  const [isDraft, setIsDraft] = useState(false);
  const [paymentValue, setPaymentValue] = useState(0);
  const [errors, setErrors] = useState({});
  const [temp, setTemp] = useState(true);
  const [reqErrors, setReqErrors] = useState({});
  const [allFields, setAllFields] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [disableSign, setDisableSign] = useState(false);
  const [initiatedModal, setInitiatedModal] = useState(false);
  const [conditionalFields, setConditionalFields] = useState({});

  const defaultIDs = [
    'first_name', 'last_name', 'email', 'phone', 'designation', 'dob', 'company',
    'lic_issue_date', 'lic_exp_date', 'permit_type', 'category_of_adp', 'signature',
    'driving_lic_num', 'type_of_lic', 'issusing_authority', 'employee_id'
  ];

  const staticFields = [
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'attachments',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Attachments',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'photo',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      isCrop: true,
      title: 'Profile Picture',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'signature',
      isDisabled: disableSign,
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Signature',
      type: 'signature'
    }
  ];
  const isIssuingAuthorityDisabled = defaultFields?.some(field => field.id === 'issusing_authority' && field.isDisabled);

  useEffect(() => {
    dispatch(getAdpDefaultFields());
    dispatch(getAdpCategories(true));
    dispatch(getAdpCategories(false, false, false, profile?.current_tenant?.id));
  }, [dispatch, profile]);

  useEffect(() => {
    if (draftApp) dispatch(fetchspecificAdpLogs(draftApp));
    if (!draftApp) dispatch(clearDraftState());
  }, [dispatch, draftApp]);

  useEffect(() => {
    const isSuccess = submissionStatus?.success;
    const isError = submissionStatus?.error;
    const isDraftSuccess = initiateDraftApplicationAction?.success;
    const isDraftError = initiateDraftApplicationAction?.error;
    const isDeleteDraftSuccess = actionDeleteDraftApplication?.success;
    const isDeleteDraftError = actionDeleteDraftApplication?.error;

    const paymentByAdmin = adpSettings?.enable_adp_payment_by_admin_after_application;
    const hasPayment = adpSettings?.enablePermitFees && adpSchemaSettings?.charge_fees_per_adp_permit;

    const clearAllStates = () => {
      dispatch(clearState());
      dispatch(clearDraftState());
      dispatch(handleClearApprovedApplicationState());
    };
    const goToLogs = () => {
      history.push('/adp/logs');
    };
    if (isSuccess || isError || isDraftSuccess || isDraftError || isDeleteDraftSuccess || isDeleteDraftError) {
      // Case: Submission (success) or Draft (success) leads to payment
      if (hasPayment && !isDraft && (isSuccess || isDraftSuccess)) {
        if (paymentValue > 0) {
          if (paymentByAdmin) {
            setStage('payment');
          } else {
            goToLogs();
          }
        } else {
          handleNavigation(false, 0);
        }
      } else {
        goToLogs();
      }
      setState(prev => ({ ...prev, loader: false }));
      clearAllStates();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionStatus, isDraft, history, dispatch, adpSettings, paymentValue,
    initiateDraftApplicationAction, actionDeleteDraftApplication]);

  useEffect(() => {
    let newAnswersObject = state.answers;
    if (draftApp) newAnswersObject = applicationDetails;
    if (defaultFields?.length > 0) {
      const default_fields = defaultFields.map((ele) => {
        if (['first_name', 'last_name', 'phone'].includes(ele.id)) {
          return {
            ...ele,
            disable: false,
            type: ele.id === 'phone' ? 'telephone' : 'string',
            required: true
          };
        }
        if (['email', 'designation'].includes(ele.id)) {
          return {
            ...ele,
            disable: false
          };
        }
        return ele;
      });
      const combinedFields = [...default_fields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors,
        signature: newAnswersObject?.signature ? !Object.keys(newAnswersObject?.signature) : true,
        attachments: reqAttach?.length > 0 ? false : !newAnswersObject?.attachments?.length > 0
      };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering?.length) { // sorted - if ordering
        Fields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        Fields = filteredFields; // without sorted - if no ordering
      }
      setMergedFields(Fields);
      Fields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else if (ele.required) {
          if (defaultIDs.includes(ele.id)) {
            fieldErros = { ...fieldErros, [ele.id]: (!newAnswersObject[ele.id]) };
          } else {
            fieldErros = { ...fieldErros, [ele.id]: (!newAnswersObject.response?.[ele.id]) };
          }
        }
      });
      setDisableSign(combinedFields?.some(ele => ele.id === 'signature' && ele?.isDisabled === true));
      setConditionalFields(condFields);
      setErrors(fieldErros);
    } else {
      dispatch(getAdpDefaultFields());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFields, dispatch, applicationDetails]);

  useEffect(() => {
    const setIssuingAuthorityOptions = (allStates) => {
      const all = mergedFields?.map((ele) => {
        if (ele.id === 'issusing_authority') {
          return {
            ...ele,
            values: allStates?.map(each => ({
              key: each?.state,
              value: each?.state
            })),
            default_value: {}
          };
        }
        return ele;
      });
      setAllFields(all);
    };
    if (mergedFields?.length > 0 && countryState?.length > 0 && !isIssuingAuthorityDisabled) {
      setIssuingAuthorityOptions(countryState);
    } else {
      setAllFields(mergedFields);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergedFields, countryState]);

  useEffect(() => {
    const fetchCountryStates = async () => {
      if (!defaultFields?.length || isIssuingAuthorityDisabled) return;
      try {
        AWS.config.update({
          region: process.env.REACT_APP_REGION
        });
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
        });
        await AWS.config.credentials.getPromise();
        const docClient = new AWS.DynamoDB.DocumentClient({
          region: process.env.REACT_APP_REGION
        });

        const threeCharCode = getThreeLetterCountryCode(countrycode);
        if (!threeCharCode) return;
        const params = {
          TableName: 'aeros_countries_states',
          KeyConditionExpression: 'country_large_code = :country_large_code',
          ExpressionAttributeValues: {
            ':country_large_code': threeCharCode
          }
        };
        const data = await docClient.query(params).promise();
        setCountryState(data.Items);
      } catch (error) {
          toast.error('Error occured while fetching country states');
      }
    };
    fetchCountryStates();
  }, [defaultFields, installationId, countrycode, isIssuingAuthorityDisabled]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.answers?.req_attachments, reqAttach]);

  useEffect(() => {
    if (paymentActionStatus?.success) {
      history.push('/adp/logs');
    } else if (paymentActionStatus?.error) {
      setStage('payment');
    }
  }, [paymentActionStatus, dispatch, history]);

  useEffect(() => {
    if (checkApprovedApplicationAction?.success && state.loader) {
      setState(prevState => ({ ...prevState, loader: false }));
      // CHECK EXISTING APPROVED APPLICATION IF NOT AND GO FOR SUBMIT APPLICATION
      if (!existingApprovedAppInfo?.matching_permits?.length > 0) {
        dispatch(handleClearApprovedApplicationState());
        handelSubmit(false, false, true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkApprovedApplicationAction, state, existingApprovedAppInfo]);

  useEffect(() => {
    if (temp && applicationDetails?.id) {
      const all_attachments = applicationDetails?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = applicationDetails?.req_attachments
        && Object.keys(applicationDetails?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: applicationDetails?.req_attachments[key].map(att => all_attachments[att]) }), {});
      const sign = applicationDetails.signature;
      const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
      setState({
        ...state,
        answers: {
          ...applicationDetails,
          signature: isEmptySignature ? null : applicationDetails?.signature,
          req_attachments: requireAttachments
        }
      });
      setTemp(false);
    }
  }, [temp, applicationDetails, state]);

  useEffect(() => {
    if (initiateStatus?.success) {
      setState(prevState => ({ ...prevState, loader: false }));
      if (initiatedPermitData?.length > 0) {
        setInitiatedModal(true);
        dispatch(handleClearInitiateState());
      } else {
        dispatch(handleClearInitiateState());
        handelSubmit(true, false, false);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initiateStatus, dispatch, initiatedPermitData]);

  useEffect(() => () => {
    dispatch(clearDetailsState());
    setStage('application');
  }, [dispatch]);

  const handleCheckInitatePermits = () => {
    let phone = (state.answers?.phone
      && (state.answers?.phone[0] + state.answers?.phone.slice(1).replace(/[^\d]/g, '')).trim())
      || undefined;
    let email = state?.answers?.email || undefined;
    let driving_lic_num = state?.answers?.driving_lic_num || undefined;
    setState(prevState => ({ ...prevState, loader: true }));
    dispatch(checkInitiatePermit(phone, email, undefined, driving_lic_num));
  };

  const getValue = (item) => {
    const idExistsInDefault = defaultIDs.includes(item.id);
    const attachType = item?.type === 'attachments'
      ? state.answers.response?.[item?.id]?.length > 0
      : state.answers.response?.[item?.id];
    const answer = idExistsInDefault ? state.answers[item?.id] : attachType;
    return !answer;
  };

  const getDefAnswer = (item) => {
    if (state.answers[item.id]) {
      return state.answers[item.id];
    }
    return valueType(item)?.value;
  };

  const getCusAns = (item) => {
    if (state.answers.response?.[item.id]) {
      return state.answers.response?.[item.id];
    }
    return valueType(item)?.value;
  };

  const handleAnswerChanged = (section, answer, fieldId) => {
    if (conditionalFields?.[fieldId]) { // check the conditional fields
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        const fieldValue = answer;
        const enableCondition = conditionValues.some(value => fieldValue === value?.value);
        const defaultValue = valueType(item)?.value;
        if (item.required) {
          handleFieldErrorChanged(
            item.id,
            enableCondition ? getValue(item) : false
          );
        }
        if (enableCondition) {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: getDefAnswer(item) }
                : { response: { ...prev.answers.response, [item.id]: getCusAns(item) } }
              )
            }
          }));
        } else {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: defaultValue }
                : { response: { ...prev.answers.response, [item.id]: defaultValue } }
              )
            }
          }));
        }
      });
    }
    if (section === 'response') { // check custom field answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          response: {
            ...prevState.answers.response,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments') { // check required attachment answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments: {
            ...prevState.answers.req_attachments,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments_dates') {
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments_details: {
            ...prevState.answers.req_attachments_details,
            [section]: {
              ...prevState.answers.req_attachments_details?.[section],
              [fieldId]: answer
            }
          }
        }
      }));
    } else { // check default field answers
      setState(prevState => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  const handleFieldErrorChanged = (id, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [id]: value }));
  };

  const getRequired = (data, isFieldError) => {
    let requiredKeys = {
      signature: true,
      attachments: true
    };
    let FieldError = { ...errors };
    if (data?.length !== 0) {
      data.forEach((ele) => {
        if (ele.required) {
          if (defaultIDs.includes(ele.id)) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers[ele.id] };
          } else if (!(defaultIDs.includes(ele.id))) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers.response?.[ele.id] };
          }
        }
      });
    }
    return isFieldError ? FieldError : requiredKeys;
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers?.attachments?.filter(e => e?.attachment_id !== attachment?.attachment_id);
    setState({ ...state, answers: { ...state.answers, attachments: filtereAttachments } });
  };

  const getFileNames = async (count, code) => {
    const response = await GetFileName.getPermitUploadFileName(count, code, 'driver_permit');
    return response;
  };

  const doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      undefined,
      undefined,
      getErrorAlert
    );
    return response;
  };

  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'driver_permit',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'driver_permit', getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const handleCheckApprovedApplication = () => {
    const { driving_lic_num } = state.answers;
    setState(prevState => ({ ...prevState, loader: true }));
    dispatch(checkExistingApprovedApplication({ unique_id: driving_lic_num }));
  };

const invoiceObject = useMemo(() => getFeeWithInvoice({
    description: 'On Application Submission',
    feeCategoryData: feeTypesList,
    taxData: adpSchemaSettings?.tax_details,
    applicationType: 'New',
    applicationFor: 'on_application_submission',
    selectedCategory: state.answers?.category_of_adp,
    isVatApplicable: adpSchemaSettings?.isVatApplicable,
    roundTo: 2
  }) || {}, [feeTypesList, adpSchemaSettings, state.answers.category_of_adp]);

  const handlePayment = useCallback((tokenDetails, payment_value) => {
    const app_id = draftApp || getApplicationResponse?.application_id;
    if (tokenDetails && app_id) {
      const payload = {
        payment_info: {
          id: tokenDetails?.token?.id || null,
          amount: payment_value || 0,
          description: invoiceObject?.description || '',
          fee_type: invoiceObject?.fee_type,
          other_info: {
            ...invoiceObject,
            currency: profile?.portal_airport?.airport_settings?.currency || '$'
          },
          payment_by_tenant: adpSchemaSettings?.adp_payment_type_for_tenant === 'offline'
        }
      };
      dispatch(makeAdpPayment(app_id, payload));
    }
  }, [getApplicationResponse, draftApp, invoiceObject, profile, adpSchemaSettings, dispatch]);

  const handleOfflinePayment = useCallback((tokenDetails, payment_value) => {
    handlePayment(tokenDetails, payment_value);
  }, [handlePayment]);

  const handleNavigation = (path = false, paymentVal) => {
    const app_id = draftApp || getApplicationResponse?.application_id;
    const payload = {
      skip_payment: true,
      payment_info: {
        id: null,
        amount: paymentVal || 0,
        description: invoiceObject?.description || '',
        fee_type: invoiceObject?.fee_type || 'on_application_submission',
        other_info: {
          ...invoiceObject,
          currency: profile?.portal_airport?.airport_settings?.currency || '$'
        }
      }
    };
    if (path) {
      history.push('/adp/logs');
    } else {
      dispatch(makeAdpPayment(app_id, payload));
    }
  };

  const handelSubmit = async (disableCheck, isDraftApp, checkPermit) => {
    const { attachments, signature, photo, lic_exp_date, lic_issue_date, dob, req_attachments } = state.answers;
    let error = { ...errors,
      attachments: !reqAttach?.length > 0 ? !state.answers.attachments?.length : false,
      photo: !state.answers?.photo?.length > 0,
      signature: !state.answers.signature
    };
    setIsDraft(isDraftApp);
    let dataObject = {};
    // HANDLE APPROVED APPLICATION API BASED ON ADMIN SETTING ENABLED OR NOT
    if (!disableCheck && !isDraftApp && !checkPermit) {
      if (adpSettings?.disable_more_than_one_approved_permit_adp) {
        handleCheckApprovedApplication();
        return;
      }
      handelSubmit(false, false, true);
      return;
    }
    let newDate = moment().startOf('day');

    let byPassMandatoryFields = false; // WE ARE USING THIS TO SAVE AS DRAFT APPLICATION

    let noErrors = Object.keys(error).every(k => (error[k] === false));
    let noReqErrors = Object.keys(reqErrors).every(k => reqErrors[k] === false);
    let dateOfBirth = moment(dob);
    let age = newDate.diff(dateOfBirth, 'year', true);
    let issueDate = moment(lic_issue_date);
    let expireDate = moment(lic_exp_date);
    if (isDraftApp) {
      byPassMandatoryFields = true;
    }
    if ((lic_issue_date && issueDate.diff(moment(new Date())) > 0) && !byPassMandatoryFields) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Issue Date cannot be a future date. Please modify the date and try again.'
      }));
    } else if ((lic_exp_date && expireDate.diff(moment(new Date())) < 0) && !byPassMandatoryFields) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Expire Date should be a future date. Please modify the date and try again.'
      }));
    } else if (lic_exp_date && lic_issue_date && issueDate.diff(expireDate) > 0 && !byPassMandatoryFields) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Issued date should not be older than License Expiry date.'
      }));
    } else if (dob && ((dob && age <= 17)) && !byPassMandatoryFields) {
      setState(prevState => ({
        ...prevState,
        dateError: 'Applicant age should be 17 years or above.'
      }));
    } else if ((noErrors && noReqErrors) || byPassMandatoryFields) {
      if (!isDraftApp && !disableCheck && checkPermit && !byPassMandatoryFields) {
        handleCheckInitatePermits();
        return;
      }
      if (byPassMandatoryFields) dispatch(handleClearApprovedApplicationState());

      setState(prevState => ({ ...prevState, loader: true, dateError: '' }));
      // for required attachment id's
      const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
        if (Array.isArray(attachment)) {
          acc[key] = attachment
            .map(item => item?.attachment_id)
            .filter(id => typeof id === 'string');
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});
      const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
        ? attachments.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];
      const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'driver_permit');
      const photoId = (photo?.length > 0 && Array.isArray(photo))
        ? photo.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];
      const attachmentFields = customFields.filter(schemaField => (
        schemaField?.type === 'attachments'
      ));

      const customSignFields = allFields.filter(field => field.type === 'signature') || [];

      if (customSignFields.length > 0) {
        for (let index = 0; index < customSignFields.length; index++) {
          const customSignField = customSignFields[index]?.id;
          const schemaField = customSignFields[index];
          const customSignValue = Array.isArray(state.answers?.response?.[customSignField])
            ? state.answers?.response?.[customSignField]
            : !!state.answers?.response?.[customSignField] && [state.answers?.response?.[customSignField]];
          if (schemaField?.type === 'signature' && customSignValue?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            state.answers.response[customSignField] = await handleUploadAttachments(customSignValue, 'driver_permit') || [];
          }
        }
      }

      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
            state.answers.response[attachmentField] = state.answers.response[attachmentField]
              .map(item => item?.attachment_id)
              .filter(id => typeof id === 'string');
          }
        }
      }
      const adp_category_id = adpCategories.find(c => (c.name === state.answers?.category_of_adp) && c.id);

      setPaymentValue(invoiceObject?.grandTotal || 0);

      dataObject = {
        ...dataObject,
        ...state.answers,
        application_type: 'New',
        photo: photoId,
        attachments: attachmentId,
        req_attachments: attchList,
        adp_category: adp_category_id?.id || null,
        signature: signatureId?.[0] || [],
        status: isDraftApp ? 'Draft' : null,
        dob: dob && state.answers.dob ? moment(state.answers.dob).format('YYYY-MM-DD') : state.answers.dob,
        lic_exp_date: lic_exp_date && (state.answers.lic_exp_date
          ? moment(state.answers.lic_exp_date).format('YYYY-MM-DD')
          : state.answers.lic_exp_date),
        lic_issue_date: lic_issue_date && (state.answers.lic_issue_date
          ? moment(state.answers.lic_issue_date).format('YYYY-MM-DD')
          : state.answers.lic_issue_date),
        employee_id: state.answers?.employee_id || null,
        issusing_authority: state.answers?.issusing_authority || null
      };
      let data = { ...dataObject };
      if (photoId?.length) {
        data.attachments.push(...photoId);
      }
      if (reqAttach?.length > 0 && Object.keys(req_attachments || {})?.length > 0) {
        data.attachments.push(...Object.values(attchList).flat());
      }
      if (allFields.length !== 0) {
        let checkbox = allFields.filter(ele => ele.type === 'boolean');
        if (checkbox?.length !== 0) {
          checkbox.forEach((ele) => {
            if (data.response && !data.response[ele.id]) {
              data = { ...data, response: { ...data.response, [ele.id]: false } };
            }
          });
        }
      }
      if (draftApp && (applicationDetails?.status === 14 || isDraftApp)) {
        dispatch(initiateDraftPermit(data, draftApp));
      } else {
        dispatch(initiateApplication(data));
      }
    } else {
      setState(prevState => ({
        ...prevState,
        formErrors: true,
        dateError: false,
        loader: false
      }));
      if (lic_exp_date && lic_issue_date && expireDate.diff(issueDate) > 0) {
        setState(prevState => ({
          ...prevState,
          dateError: false,
          formErrors: true,
          loader: false
        }));
      }
    }
  };

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  const getAnswers = fieldId => ( // Helper function to get answers
    defaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  const fieldAnswers = {};
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const remove = () => {
    dispatch(deleteSaveAsDraftAdpLog(draftApp));
    setConfirmDelete(false);
  };

  return (
    <>
      <Loading
        loadingStatus={!allFields?.length > 0 || submissionStatus?.pending || state.loader || getSchemaStatus?.loading
          || actionApplicationDetails?.loading || getDetatilStatus
        }
      />
      <SectionHeader
        centered
        icon={PERMITMODULE}
        translationID=" "
        defaultTitle={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application`}
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute="/adp/logs"
      />
      {stage === 'application' && (
      <div className={styles.container}>
        <div className={styles.headder}>
          <FormattedMessage
            id=" "
            defaultMessage={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application Form`}
          />
        </div>
        <span className={styles.note}>
          <FormattedMessage
            id="application.note"
            defaultMessage="Please note: "
            tagName="b"
          />
          <FormattedMessage
            id=" "
            defaultMessage={`Renewal ${profile?.permit_management?.driver_permit || 'ADP'}
              applications should be submitted through the existing application`}
          />
        </span>
        <div className={styles.childContainer}>
          <CustomFields
            handleAnswerChanged={(a, b) => (handleAnswerChanged(defaultIDs.includes(b) ? 'answers': 'response', a, b))}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            handleAttachmentFailedAlert={getErrorAlert}
            handleAutoUploadAttachments={uploadtoS3}
            getLoadingStatus={getLoadingStatus}
            entityName="driver_permit"
            showFormErrors={state.formErrors}
            isSignatureUpload
            applicationType="New"
            requiredMap={getRequired(allFields, draftApp)}
            fields={allFields}
            answers={fieldAnswers}
            adp
            forQuestionMarkHelp
          />
          <div>
            <Collapsible
              adp
              title="Note:"
              openOnMount={false}
              collapsibleHeight="0"
            >
              {notes?.length !== 0 && (
                <div style={{ height: 'auto' }}>
                  {notes?.map((ele, i) => <p>{`(${i + 1}) ${ele}`}</p>)}
                </div>
              )}
            </Collapsible>
          </div>
          {reqAttach?.length !== 0 && (
          <div>
            <Collapsible
              adp
              title="Required Attachments:"
              openOnMount={false}
              collapsibleHeight="0"
              overflowVisible
            >
                <div style={{ height: 'auto' }}>
                  {reqAttach?.map((ele) => {
                    const attachmentName = typeof ele === 'object' ? ele.attachmentName : ele;
                    return (
                      <ReqAttachments
                        {...staticFields[0]}
                        handleAnswerChanged={(a, b) => handleAnswerChanged(
                          'req_attachments', a, `${attachmentName}_${b}`
                        )}
                        attachments={state.answers?.req_attachments?.[`${typeof ele === 'object'
                          ? ele.attachmentName
                          : ele}_attachments`
                        ]}
                        showFieldErrors={state.formErrors}
                        entityName="driver_permit"
                        getLoadingStatus={getLoadingStatus}
                        handleAutoUploadAttachments={uploadtoS3}
                        handleRemove={handleRemoveAttachments}
                        handleAttachmentFailedAlert={getErrorAlert}
                        adpAttachments
                        attachmentName={attachmentName}
                        dateDetails={ele}
                        adpAnswers={state.answers}
                        handleDateChange={(a, b) => handleAnswerChanged(
                          'req_attachments_dates', a, `${attachmentName}_${b}`
                        )}
                        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
                      />
                    );
                  })}
                </div>
            </Collapsible>
          </div>
          )}
          <div>
            <CustomFields
              fields={reqAttach?.length > 0
                ? staticFields.filter(field => field.id !== 'attachments')
                : staticFields}
              answers={state.answers}
              showFormErrors={state.formErrors}
              adpAttachments
              isSignatureUpload
              entityName="driver_permit"
              applicationType="New"
              getLoadingStatus={getLoadingStatus}
              handleAutoUploadAttachments={uploadtoS3}
              handleRemove={handleRemoveAttachments}
              handleAttachmentFailedAlert={getErrorAlert}
              requiredMap={getRequired(staticFields)}
              handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              profilePic
              isCrop={staticFields?.filter(s => s.isCrop === true)}
              adp
              forQuestionMarkHelp
            />
          </div>
        </div>
        <div className={styles.submitButton}>
          {!existingApprovedAppInfo?.matching_permits?.length > 0 && (
            <p className={styles.errorMessage}>
              {state.dateError}
              {(!state.dateError && state.formErrors) && (
                <>
                * Please fill all the required fields
                </>
              )}
            </p>
          )}
          {existingApprovedAppInfo?.matching_permits?.length > 0 && (
            <p className={styles.errorMessage}>
                <>
                <FormattedMessage
                  id="adp.existing.application.warning.message"
                  defaultMessage={'This applicant is already registered. Please re-enter data or otherwise apply for an ADP Renewal application.'}
                />
                </>
            </p>
          )}
          <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
          {applicationDetails && applicationDetails?.status === 14 && (
            <Button
              action="danger"
              onClick={() => handleConfirmDelete()}
              translationID="assets.delete"
              defaultText="Delete"
            />
          )}
            <div style={{ whiteSpace: 'nowrap', margin: '0 5px' }}>
            <Button
              action="primary"
              onClick={() => handelSubmit(true, true, false)}
              translationID="inspections.complete_inspections.save_as_draft"
              defaultText="Save as Draft"
              disabled={load}
            />
            </div>
            <Button
              action="secondary"
              onClick={() => handelSubmit(false, false, false)}
              translationID="adp.submit"
              defaultText="Submit"
              disabled={load}
            />
          </div>
        </div>
      </div>
      )}
      {stage === 'payment' && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {adpSchemaSettings?.adp_payment_type_for_tenant === 'offline' ? (
            <>
              <OfflinePayment handlePayment={handleOfflinePayment} paymentData={invoiceObject?.grandTotal || 0} />
            </>) :(
              <PaymentPage
                paymentData={paymentValue}
                profileCurrency={profile?.portal_airport?.airport_settings?.currency || '$'}
                isAdmin
                handlePayment={handlePayment}
                handelNavigation={handleNavigation}
                airportSettings={profile?.portal_airport?.airport_settings}
                paymentModule="driver_permit"
              />
            )}
        </div>
      )}
      <Modal
        showIn={initiatedModal}
        onClose={() => setInitiatedModal(false)}
        minHeight="150px"
        width="554px"
      >
        <div style={{ padding: '20px 20px 10px' }}>
          <FormattedMessage
            id="adp.application.restriction.warning.message.one"
            tagName="h5"
            defaultMessage={` An ${profile?.permit_management?.driver_permit || 'ADP'}
              application has already been initiated for this user.
              Kindly cancel the existing one if you need to re-initiate an application.
            `}
          />
          <FormattedMessage
            id="adp.application.restriction.warning.message.two"
            tagName="h5"
            defaultMessage={'For renewal of an approved application, please initiate the renewal from within the application itself.'}
          />
        </div>
        <div className={styles.submitButton}>
          <Button
            action="secondary"
            onClick={() => setInitiatedModal(false)}
            translationID="inspections.list.ok"
            defaultText="OK"
            />
        </div>
      </Modal>
      <DeleteConfirmation
        isActive={confirmDelete}
        onClose={() => toggleConfirmDelete()}
        confirmDelete={() => remove()}
      />
      {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true, true, false)} />}
    </>
  );
};

export default AdpDriverPortalForm;
